import '../../css/base.css';
import scenery4_large from '../../img/scenery4_large.jpg'
import scenery4_medium from '../../img/scenery4_medium.jpg'
import scenery4_small from '../../img/scenery4_small.jpg'

const Kayaks = () => {

  return (
    <div>
      <h2 className="your-stay-section-heading">Kayaks</h2>
      <p className="your-stay-text">There are two sit on top red Perception kayaks (one single and one double) for you to use with paddles.  They are easy to use and guarantee hours
                                    of fun.  Explore the coastline or just use them as floating platforms for kids to jump in from.  They are very easy to
                                    turn and get back on if you fall in.  Although only children really like to do that!  Dry Island has a cove on the far side to 
                                    explore and along with the headland towards Corran there are some great places to jump into the water from the rocks.  There is also a sit-in sea kayak but I 
                                    would ask that you only use this if you have the skills.  This is because you need training to get able to get back 
                                    in if you capsize.  Easier said than done as I have just mastered this act myself. 
      </p>                                            
      <div className="imagesBackgroundColour">
        <picture>
          <source srcset={`${scenery4_small} 1x,${scenery4_medium} 2x`} media="(max-width: 600px)" />
          <img srcset={`${scenery4_medium} 1x,${scenery4_large} 2x`}
            src={scenery4_medium} alt="Kayaking at Dry Island" className="image"
          />
        </picture>
      </div>             
      <p className="your-stay-text">There are various pieces of kit to help you enjoy the water in the locked cupboards.  The small key is in the draw in the kitchen.
                                    We have lifejackets, a variety of wetsuit sizes and boots and gloves.  And snorkeling masks and fins.  So have some fun and just give
                                    it a good dry before you store it away.  I would advise you bringing your own wetsuits if possible as we can't guarantee there will be one that
                                    fits.
      </p>         
      <p className="your-stay-text">Safety.  The water is a very cold 6-10 degrees and so wetsuits and lifejackets are essential if you are venturing far.  The main risk is around wind
                                    as the kayaks do catch the wind.  Test it our near the shore and paddle into the wind on your outward journey if it is strong. If you do fall in then make sure you 
                                    grab the kayak to stop it blowing away.  You obviously use them at your own risk but staying near the shore on a nice calm day they are 
                                    very safe.
      </p>                                            
    </div>
  );
}

export default Kayaks;